import gql from 'graphql-tag';
import { ACCOUNT_CONTACT_FRAGMENT } from './fragment';

export const UPDATE_ACCOUNT_CONTACT = gql`
  ${ACCOUNT_CONTACT_FRAGMENT}
  mutation UpdateAccountContact($input: UpdateAccountContactInput!) {
    accountMutation {
      result: updateAccountContact(input: $input) {
        success
        error
        entity {
          ...AccountContactFields
        }
      }
    }
  }
`;
